import React from 'react';
import PropTypes from 'prop-types';

import Group from '../../../../components/Group';
import Column from '../../../../components/Column';

import HoursInput from './components/HoursInput';

const Hours = (props) => {
  const { errors, values, onChange } = props;

  return (
    <Group title="Hours">
      <Column>
        <HoursInput
          hourType="normal"
          title="Monday-Friday Hours"
          onChange={onChange}
          values={values}
          errors={errors}
        />
        <HoursInput
          hourType="sunday"
          title="Sunday Hours"
          onChange={onChange}
          values={values}
          errors={errors}
        />
      </Column>
    </Group>
  );
};

export default Hours;

Hours.propTypes = {
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

Hours.defaultProps = {
  errors: {},
};
